import { makeUrl } from 'app/common/helpers/url';
import { slugify } from 'app/common/helpers/strings';
import {
  getLocalQueryParameters,
  makeGoodsUrl,
} from 'app/desktop/helpers/flyout';

export function transformCategoriesFlyouts(
  categoriesFlyout,
  couponsSubnavLinks
) {
  return categoriesFlyout.reduce((result, flyout) => {
    if (flyout) {
      switch (flyout.id) {
        case 'coupons':
          flyout = transformCoupons(flyout, couponsSubnavLinks);
          break;
        case 'goods':
          flyout = transformGoods(flyout);
          break;
        case 'local':
          flyout = transformLocal(flyout);
          break;
        case 'getaways':
          flyout = transformFlyout(flyout);
          break;
      }
      result.push(flyout);
    }
    return result;
  }, []);
}

/**
 * Layout the categories using columns up to 3,
 * max 6 items per column
 * @param {Array} categories - categories
 */
function layoutCategories(categories, id) {
  if (categories.length === 0) {
    return [];
  }

  categories = categories.filter(
    category =>
      !['all-deals', 'all-destinations', 'all-stores'].includes(category.id)
  );

  if (id === 'local') {
    categories = categories.slice(0, 12);
  }

  let count = 6;

  if (id === 'coupons') {
    count = 8;
    categories = categories.slice(0, 24);
  }

  return categories.reduce(
    (acc, item) => {
      const links = acc[acc.length - 1]; //last links
      if (links.length < count) {
        links.push(item);
      } else {
        acc.push([item]);
      }
      return acc;
    },
    [[]]
  );
}

function transformLocal(local) {
  if (!local) {
    return local;
  }
  const { categories, baseUrl } = local;

  local.categories = categories.map(category =>
    Object.assign(category, {
      url: category.url || makeUrl(baseUrl, getLocalQueryParameters(category)),
    })
  );

  return transformFlyout(local);
}

function transformCoupons(coupons, couponsSubnavLinks) {
  if (!coupons) {
    return coupons;
  }

  if (Array.isArray(couponsSubnavLinks) && couponsSubnavLinks.length) {
    coupons.couponsSubnavLinks = couponsSubnavLinks;
  }

  return transformFlyout(coupons);
}

function transformFlyout(flyout) {
  const { id, categories } = flyout;
  categories.forEach(item => {
    const { name, text, link, url } = item;

    Object.assign(item, {
      id: item.id || slugify(name || text || ''),
      url: url || link,
      name: name || text,
      tab: `${id}-tab`,
    });
  });
  return Object.assign({}, flyout, {
    links: layoutCategories(categories, id),
  });
}

function transformGoods(goods) {
  if (!goods) {
    return goods;
  }

  const { categories, flatLinks, id } = goods;
  goods.categories = categories.map(category => ({
    ...category,
    url: makeGoodsUrl(category),
  }));
  const clearanceLink = flatLinks.find(link => link.id === 'goods-clearance');
  goods.categories.push({
    ...clearanceLink,
    url: makeGoodsUrl(clearanceLink),
    tab: 'goods',
  });
  goods.links = layoutCategories(goods.categories, id);
  return goods;
}
